module.exports = __webpack_public_path__ + "93ef7b161714966dc0bc6a1448122f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/background.png
// module id = 135
// module chunks = 0